exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-tooltip__content span[data-v-76800659] {\n  text-align: left;\n  display: block;\n  width: 100%;\n}\n", ""]);

// exports
